<template>
  <div class="p-3 flex flex-col bg-key rounded-4xl">
    <div class="flex items-center gap-1 h-9 text-l-medium text-black-white">
      <Icon icon="Writing-Wireframe-Feedback" class="size-6" />
      <span>{{ $t('setting.about.contact.title') }}</span>
    </div>

    <p class="text-m-medium text-text-glass-default">
      {{ $t('setting.about.contact.description') }}
    </p>
  </div>
</template>

<script lang="ts" setup>
  import { Icon } from '@rapoo/element'
</script>
